import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { fetch } from '../../actions'
import { useFetchPostV2, useSavePost } from '../../components/Hooks/Conexao'
import { Drawer, Switch, Input, Radio, Button, Alert } from 'antd';
import Mensagens from '../../components/Mensagens';
import Spinner from '../../components/Spinner/Spinner';

function Func(props){
    const [selectedValue, setSelectedValue] = useState('');
    const [lojas, listar, loading] = useFetchPostV2(props.fetch, '/cliente', { modelo: 'cli-lojas', dados: { id: props.id } })
    const [saved, setSaved] = useState(false);

    const [save, saving] = useSavePost(props.fetch, '/cliente/save', { modelo: 'zerar-estoque', dados: { id: props.id, idLoja: selectedValue ? selectedValue.id : 0 } },
    () => {
       setSaved(true);
    });

    useEffect(() => listar(), [])

    if(loading){
        return <div style={{marginTop:40}}><Spinner /></div>
    }

    return (<div>
        {saved && <div style={{marginBottom:20}}><Alert message="Estoque zerado com sucesso" type="success" showIcon /></div>}
        <div style={{marginBottom:20}}><Button type="primary" onClick={save} loading={saving} disabled={!selectedValue || saved}>Gravar</Button></div>
         <Radio.Group onChange={e => setSelectedValue(e.target.value)} value={selectedValue}>                                
            {(lojas || []).map((x, inx) => {
                return (<Radio key={x.id} style={{display: 'block', height: '30px', lineHeight: '30px'}} value={x}>
                    {x.codigo + ' - ' + x.nome}
                    </Radio>)
            })}
        </Radio.Group>
    </div>)
    return <div><pre>{JSON.stringify(lojas, null, 2)}</pre></div>
}

export default connect(null, { fetch })(Func);